import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=795b7e7e&scoped=true"
import script from "./Arrow.vue?vue&type=script&lang=js"
export * from "./Arrow.vue?vue&type=script&lang=js"
import style0 from "./Arrow.vue?vue&type=style&index=0&id=795b7e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b7e7e",
  null
  
)

export default component.exports